import React from 'react';
import Footer from '../Footer';
import image1 from "../../images/Images Webp/Blog-1.webp";
import image2 from "../../images/Images Webp/blog-2.webp";
import image3 from "../../images/Images Webp/blog3.webp";
import image4 from "../../images/Images Webp/tinywow_img_man_placing_eng_60034854.webp";

const Blog4 = () => {
    return (
        <>
            <div className="min-h-screen p-8 bg-grey-50">
                <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-xl p-8">
                    <h1 className="text-orange-600 text-4xl font-extrabold mb-8 text-center">
                        Prénup et Mariage Islamique en Tunisie: Allier Amour et Légalité
                    </h1>
                    <p className="text-gray-700 text-lg mb-8">
                        Ah, l&apos;amour flotte dans l&apos;air, et vous êtes prêt à vous marier en Tunisie ! Mais avant de dire oui, explorons ensemble l&apos;univers des conventions prénuptiales – ouais, ces documents légaux pratiques. Pas de soucis, on va rendre ça léger et amusant !
                    </p>

                    <img src={image1} alt="Image 1 description" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Les Conventions Prénuptiales Traditionnelles : Sadaq et Mahr
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Imaginez ceci : c&apos;est la semaine précédant votre mariage, et la tradition tunisienne apporte le Sadaq et le Mahr. Le Sadaq est comme un cadeau sincère du marié à la mariée, montrant son dévouement et sa volonté de la soutenir financièrement. Puis il y a le Mahr, un cadeau obligatoire du marié à la mariée, dont elle est légitimement propriétaire – touche pas, mon chéri ! Les conventions prénuptiales traditionnelles en Tunisie se concentrent souvent autour du Mahr, garantissant la sécurité financière de la mariée, quoi qu&apos;il arrive.
                    </p>

                    <img src={image2} alt="Image 2 description" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Des Touches Modernes : Ajouter du Peps aux Conventions Prénuptiales
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Avançons jusqu&apos;à aujourd&apos;hui, et de nombreux couples tunisiens donnent un coup de jeune à leurs conventions prénuptiales. Ce sont comme des versions 2.0, où vous pouvez être précis sur la répartition des actifs et des dettes si l&apos;impensable arrive – vous savez, une rupture. Mais souvenez-vous, elles doivent jouer gentiment avec les règles de la convention prénuptiale traditionnelle. Le Mahr reste intouchable – c&apos;est une chose sacrée qui ne peut être remplacée ou outrepassée.
                    </p>

                    <img src={image3} alt="Image 3 description" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        Cool ou Pas ? Le Scoop sur les Conventions Prénuptiales Modernes
                    </h2>
                    <p className="text-gray-700 mb-6">
                        Maintenant, les conventions prénuptiales modernes, c&apos;est cool en Tunisie ? C&apos;est un peu un mélange. Tant qu&apos;elles respectent les valeurs et les coutumes tunisiennes, elles sont bonnes à partir. La plupart des savants pensent qu&apos;elles sont pratiques dans le monde d&apos;aujourd&apos;hui. Mais, et c&apos;est crucial, elles doivent être équitables. Les deux partenaires doivent savoir à quoi ils s&apos;engagent, sans manigance.
                    </p>

                    <img src={image4} alt="Image 4 description" className="w-full h-auto mb-8 rounded-lg shadow-md" />

                    <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">
                        En Conclusion : Amour, Légalité et Heureux pour Toujours
                    </h2>
                    <p className="text-gray-700">
                        Voilà ! Les conventions prénuptiales font partie de la vie tunisienne depuis toujours, et elles évoluent avec le temps. Que vous restiez classique ou que vous ajoutiez une touche moderne, l&apos;objectif est le même – se protéger mutuellement et commencer votre aventure matrimoniale avec confiance. Et si vous êtes en Tunisie et avez besoin d&apos;aide avec votre convention prénuptiale, des experts juridiques sont à portée de main. À l&apos;amour, à la loi, et à vivre heureux pour toujours.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Blog4;
